import { createFileRoute } from '@tanstack/react-router';
import { PaySlipLayoutRegistryPage } from './-components/PaySlipLayoutRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/pay-slips/')({
  component: PaySlipLayoutRegistryPage
});